import type { RouteLocationNormalized, RouteLocationRaw } from 'vue-router'

type Redirect = {
  condition?: (to: RouteLocationNormalized) => boolean
  from: ((to: RouteLocationNormalized) => RouteLocationRaw) | string
  to: (to: RouteLocationNormalized) => RouteLocationRaw
}

const redirects: Redirect[] = [
  {
    // redirect all account pages with redeem query param to home
    condition: (to) => 'redeem' in to.query,
    from: '/account',
    to: (to) => ({ path: '/', query: to.query }),
  },
  {
    from: '/my-orders',
    to: () => ({ path: '/my-orders/single-orders' }),
  },
  {
    from: '/play-now',
    to: () => ({ path: '/' }),
  },
  {
    from: '/play-now/lotteries',
    to: () => ({ path: '/draw' }),
  },
  {
    from: '/play-now/scratchcards',
    to: () => ({ path: '/scratch' }),
  },
]

export default defineNuxtRouteMiddleware((to, from) => {
  const localePath = useLocalePath()

  const redirect = redirects.find((r) => {
    const fromPath = typeof r.from === 'function' ? r.from(from) : r.from

    return localePath(fromPath) === localePath(to.path) && (!r.condition || r.condition(to))
  })

  if (redirect) {
    return navigateTo(localePath(redirect.to(to)))
  }

  const isScratchcardEnabled = useIsScratchcardEnabled()
  const isKenoEnabled = useIsFeatureFlagEnabled('keno')

  if (localePath(to.path) === localePath('/scratch') && !isScratchcardEnabled) {
    return navigateTo(localePath('/'))
  }

  if (localePath(to.path) === localePath('/keno') && !isKenoEnabled) {
    return navigateTo(localePath('/'))
  }
})
